module.exports = __webpack_public_path__ + "img/jean.453f7976.webp";